import React from 'react';

const LINKS = [
  { label: 'X', href: 'https://x.com/nicoypei' },
  { label: 'Email', href: 'mailto:nicopei321@gmail.com' },
  { label: 'GitHub', href: 'https://github.com/giffiecode' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/nico-p-a2770a136/' },
  { label: 'Goodreads', href: 'https://www.goodreads.com/user/show/66639895-nico-p' },
];

function AboutContent() {
  return (
    <section id="about" className="intro">
      {/* James Turrell inspired color field */}
      <a className="orb" href="https://jamesturrell.com/" target="_blank" rel="noopener noreferrer" aria-label="Inspired by James Turrell">
        <span className="turrell-field" />
      </a>
      <p className="orb-tag">field 01 · inspired by james turrell</p>

      <h1>Nico Pei</h1>
      <p className="role">
        Building <a href="https://rates.exchange" target="_blank" rel="noopener noreferrer">Rates Exchange</a> · New York
      </p>
      <p>Most of my time goes into market structure: how risk gets priced, how money moves, and who's on the other side of the trade.</p>
      <p>
        Previously built <span className="nolink">Logs</span> (backed by a16z), a product suite for frictionless money movement.
      </p>
      <p>
        I <a href="#writing">write</a>, <a href="#photos">photograph</a>, <a href="#photos">model</a>, and <a href="#reading">read</a>.
      </p>
      <blockquote>Be true to your own act, and congratulate yourself if you have done something strange and extravagant, and broken the monotony of a decorous age.</blockquote>

      <ul className="links">
        {LINKS.map((l) => (
          <li key={l.label}>
            <a href={l.href} target={l.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">{l.label}</a>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default AboutContent;
